import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    reset(event) {
        if (event?.detail && !event.detail.success) return

        this.element.reset()
        this.element.blur()
        this.element.focus()

    }
}
